import {BaseModel} from "../base-model";

export class ResourceRequestParams extends BaseModel {
  baseUrl: String;

  constructor(baseUrl: String) {
    super();

    this.baseUrl = baseUrl;
  }

  toString(): String {
    return this.baseUrl;
  }
}
